import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { fetchCompany, updateCompanyOfficeHours } from "../actions/index";
import CompanySettingsForm from "./CompanySettingsForm";
import { CSSTransitionGroup } from 'react-transition-group';
import { toastr } from "react-redux-toastr";

class CompanySettingsEdit extends Component {
  static propTypes = {
    fetchCompany: PropTypes.func.isRequired,
    updateCompanyOfficeHours: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    company: PropTypes.object.isRequired
  };

  componentDidMount() {
    this.props.fetchCompany();
  }

  onSubmit(state) {
    this.props
      .updateCompanyOfficeHours(state)
      .then(response => {
        if (response.payload !== undefined) {
          toastr.success("Settings saved!");
        }
      });
  }

  render() {
    if (this.props.company == undefined) {
      return (
        <CSSTransitionGroup
          transitionName="spinner"
          transitionAppear={true}
          transitionAppearTimeout={500}
        >
          <div id="content" className="spinner-content">
            <div className="vertical-center">
              <i className="fa fa-refresh fa-4x fa-spin" />
            </div>
          </div>
        </CSSTransitionGroup>
      );
    }
    return (
      <div>
        <h1>Office Hours</h1>
        <CompanySettingsForm
          handleSubmit={this.onSubmit.bind(this)}
          company={this.props.company.data}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { company: state.company.company };
}

export default connect(
  mapStateToProps,
  { fetchCompany, updateCompanyOfficeHours }
)(CompanySettingsEdit);
